import { useBemCN } from '@gik/core/utils/bemBlock';
import { Button } from '@gik/ui/Button';
import React from 'react';
import type { InjectedColorProps } from 'react-color';
import { CustomPicker, HuePicker } from 'react-color';
import { Saturation } from 'react-color/lib/components/common';
import { ColorInput } from './ColorInput';

export type BaseColorPickerProps = {
  onSubmit?: (color: string) => void;
};

export type BaseColorPickerPropsInner = BaseColorPickerProps & InjectedColorProps;

export const BaseColorPicker = CustomPicker<BaseColorPickerProps>(
  ({ onSubmit, ...pickerProps }: BaseColorPickerPropsInner) => {
    const bem = useBemCN('base-color-picker');

    const handleSubmit = React.useCallback(() => {
      onSubmit?.(pickerProps.hex);
    }, [onSubmit, pickerProps.hex]);

    const onSaturationChange = React.useCallback(
      color => {
        pickerProps?.onChange?.(color);
      },
      [pickerProps]
    );

    const onHueChange = React.useCallback(
      color => {
        pickerProps?.onChange?.({
          ...pickerProps.hsl,
          h: color.hsl.h,
        });
      },
      [pickerProps]
    );

    return (
      <div {...bem()}>
        <div {...bem('picker-block-wrapper', 'saturation')}>
          <Saturation {...pickerProps} onChange={onSaturationChange} />
        </div>
        <div {...bem('picker-block-wrapper', 'hue')}>
          <div
            {...bem('indicator')}
            style={{
              backgroundColor: pickerProps.hex,
            }}
          />
          <HuePicker {...pickerProps} onChange={onHueChange} />
        </div>
        <div {...bem('controls')}>
          <ColorInput {...pickerProps} {...bem('color-input')} variant={'default-solid'} />
          <Button {...bem('save-button')} onClick={handleSubmit}>
            Save
          </Button>
        </div>
      </div>
    );
  }
);
